
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import { ConfigState } from 'shared/state'

import TextControl from './Text.vue'

@Component({ components: { TextControl }})
export default class ThemeSelect extends Vue {

	@Prop() label?: string
	@Prop() value!: string
	@Prop() name!: string
	@Prop() config!: ConfigState

	theme = 'Default'

	@Watch('value', { immediate: true })
	valueChange(val: string) {
		this.theme = val
	}

	changeTheme() {
		if(this.theme !== this.value) {
			this.config.changeTheme(this.theme)
			this.$emit('input', this.theme)
		}
	}

}
